import React, { Component } from 'react';
import v from 'voca';
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { isEmpty, isEqual, sumBy } from 'lodash';
import { IMAGE } from "common-import/constants";
import Select from 'react-select';
import {UploadVideoModal, UploadDocumentModal, Loading} from "common-import/custom";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const propertyContractor = [
  // "name",
  "type",
  "address",
  "city",
  "country",
  "district",
  "phone",
  "mobile",
  "fax",
  "website",
  "email",
  // "taxCode",
  "origination",
  "foundedYear",
  "description",
  "typeOfCompany",
  "qualityManagement",
  "language",
  "numberOfEmployees",
  "revenue",
  "unitRevenue",
  // "awards",
  // "verifyDocuments",
  "price",
  // "pricing",
  // "listVideos",
  // "documents",
  // "finances",
  // "imageFinances",
  // "affiliations",
  // "services",
  "industries",
  "typeOfContractor",
  // "typeOfConstruction",
  // "typeOfProject",
  // "typeOfBusiness",
  // "subBusiness",
  // "mainMarkets"
];

@inject("contractorStore", "languageStore", "userStore", "masterStore", "routeStore") @observer
export default class ContractorDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contractor: {},
      current: {},
      creator: {},
      logo: null,
      cover: null,
      isLoading: true,
      enableEdit: false,
      enableEditRanking: false,
      isSaving: false,
      isApproving: false,
      isDeactivating: false,
      isUpdatingHouseLink: false,
      readMore: false,
      openDocumentModal: false,
      openVideoModal: false,
      showBlock: { industries: false, typeOfContractor: false }
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    const { contractorStore, match } = this.props;
    const res = await contractorStore.detail(match.params.id);
    this.setState({
      isLoading: false,
      contractor: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data)
    });
    await this.getUserDetailById(res.data.createdByUserId);

    // Get country value
    const { current } = this.state;
    if (isNaN(parseFloat(current.country))) {
      this.setState({ current: {...current, country: 244} });
    }
  }

  getUserDetailById = async (id) => {
    const { userStore } = this.props;
    const creator = await userStore.getUserDetailById(id);
    this.setState({ creator: creator.data });
  };

  handleMultiSelectChange = (selectedOption, property) => {
    let values = [];
    let { current } = this.state;
    selectedOption.map((item) => {
      values.push(item.value);
    });
    current[property] = values;
    this.setState({
      current,
    });
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeObject: ["verifyDocuments"],
      typeNumber: ["foundedYear", "revenue", "price"],
      typeArray: ["awards", "pricing", "listVideos", "documents", "finances", "imageFinances", "affiliations", "services", "industries", "typeOfContractor"], // "typeOfConstruction", "typeOfProject","typeOfBusiness", "subBusiness", "mainMarkets"
      typeString: ["type", "wallImage", "logo", "address", "city", "country", "district", "phone", "mobile", "fax", "website", "email", "origination", "description", "typeOfCompany", "qualityManagement", "language", "unitRevenue"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  saveChanges = async () => {
    const { contractorStore, match } = this.props;

    this.setState({ isSaving: true });
    await this.saveChangePhoto();
    const payload = this.formatPayload(this.state.current);
    const res = await contractorStore.update(payload, this.state.current.id);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }

    this.setState({
      contractor: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data),
    });

    window.toast.info('Updated successfully.');

    const resApprove = await contractorStore.approve({ id: match.params.id, approved: true });
    if (!resApprove.error) {
      this.setState({
        contractor: {...this.state.current, approved: 1},
        current: {...this.state.current, approved: 1},
      });
    }
  };

  renderEditForm = () => {
    const { current } = this.state;
    const {
      toValue,
      toSelectData,
      contractor_type,
      contractor_company_type,
      contractor_quality_management,
      contractor_sub_type,
      project_type,
      project_sub_type,
      country, city, district, language
    } = this.props.masterStore;

    const propMaster = {
      type: contractor_type,
      typeOfCompany: contractor_company_type,
      qualityManagement: contractor_quality_management,
      typeOfContractor: contractor_type,
      typeOfProject: project_type,
      industries: project_type,
      country, city, district, language
    };

    const renderOptions = (prop) => {
      const arr = [{id: 'null', label: '', value: 'null'}, ...toSelectData(propMaster[prop])];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    // For multi select
    const getSelected = (property) => {
      let sub_master = {};
      if (property === "typeOfContractor") sub_master = contractor_sub_type;
      if (property === "industries") sub_master = project_sub_type;
      if (current.hasOwnProperty(property) && current[property].length) {
        return current[property].map(item => {
          const fieldObject = item % 1 === 0 ? propMaster[property] : sub_master;
          return { label: toValue(fieldObject, item), value: item };
        });
      }
      return [];
    };
    // For multi select
    const getOptions = (property) => {
      let sub_master = {};
      if (property === "typeOfContractor") sub_master = contractor_sub_type;
      if (property === "industries") sub_master = project_sub_type;
      const main_options = toSelectData(propMaster[property]);
      const sub_options = isEmpty(sub_master) ? [] : toSelectData(sub_master);
      return [...main_options, ...sub_options].map((item) => {
        item.value = item.id; return item;
      });
    };

    return (
      <form className="block-content">
        <h4 className="block-content__title">
          <i className="fa fa-pencil" aria-hidden="true"> </i>
          Edit contractor information
        </h4>
        <div className="row">
          {
            propertyContractor.map((property, index) => {
              let element;
              if (property === 'description') {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <textarea
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    value={this.state.current[property] || ''}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else if (["language", "type", "typeOfCompany", "country", "qualityManagement"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <select
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  >
                    {renderOptions(property)}
                  </select>
                </div>
              } else if (["typeOfContractor", "industries"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <Select isMulti
                          value={getSelected(property)}
                          onChange={(e) => this.handleMultiSelectChange(e, property)}
                          options={getOptions(property)}
                  />
                </div>
              } else if (["foundedYear", "revenue", "price"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="number"
                    min={0}
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={this.state.current[property] === null ? 0 : this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="text"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={this.state.current[property] === null ? '' : this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              }

              return (
                <div className="col-xs-12 col-md-6" key={"property" + index}>
                  {element}
                </div>
              );
            })
          }
        </div>
      </form>
    )
  };

  approveContractor = async e => {
    !!e && e.preventDefault();
    const { contractorStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to approve this contractor?");
    if (continueApprove) {
      this.setState({isApproving: true});
      let result = await contractorStore.approve({ id: match.params.id, approved: true });
      this.setState({isApproving: false});
      if (!!result.error) {
        return window.toast.error("Failed: " + JSON.stringify(result.error));
      }
      current.approved = 1;
      this.setState({ contractor: current, current });
      return window.toast.info("Approved successfully.");
    }
  };

  deactivateContractor = async e => {
    !!e && e.preventDefault();
    const { contractorStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to DEACTIVATE this contractor?");
    if (continueApprove) {
      this.setState({isDeactivating: true});
      let result = await contractorStore.deactive(match.params.id);
      this.setState({isDeactivating: false});
      if (!!result.error) {
        return window.toast.error("Failed: " + JSON.stringify(result.error));
      }
      current.approved = 2;
      this.setState({ contractor: current, current });
      return window.toast.info("DEACTIVATED successfully.");
    }
  };

  renderApprove = () => {
    const { isApproving, isDeactivating } = this.state;
    const { approved } = this.state.current;
    if (approved === undefined || approved === "" || approved === true || approved === 1) {
      return (
        <div className="approve-request-section">
          {/*<h3 className="text">Deactivate this contractor </h3>*/}
          <button className="btn btn-sm btn-danger" disabled={isDeactivating} onClick={this.deactivateContractor}>
            <i className="fa fa-dot-circle-o"> </i> {isDeactivating ? 'Deactivating...' : 'Deactivate'}
          </button>
        </div>
      )
    }
    return (
      <div className="approve-request-section">
        {/*<h3 className="text">This contractor is not approved </h3>*/}
        <button className="btn btn-sm btn-primary" disabled={isApproving} onClick={this.approveContractor}>
          <i className="fa fa-dot-circle-o"> </i> {isApproving ? 'Approving...' : 'Approve'}
        </button>
      </div>
    )
  };

  updateHouseLink = async () => {
    const { contractorStore, match } = this.props;
    const { current } = this.state;
    let { isVerifiedFinances, isVerifiedLicense, isHouseLinkMember, houselinkRanking } = current;
    if (!!houselinkRanking && houselinkRanking.hasOwnProperty('mainCriterias')) {
      houselinkRanking.mainCriterias = houselinkRanking.mainCriterias.map((item) => {
        if (!!item.specific) {
          delete item.specific;
        }
        return item;
      });
    }
    this.setState({ isUpdatingHouseLink: true });
    const result = await contractorStore.updateHouseLink({
      isVerifiedFinances: isVerifiedFinances ? 1 : 0,
      isVerifiedLicense: isVerifiedLicense ? 1 : 0,
      isHouseLinkMember: !!isHouseLinkMember,
      houselinkRanking: !!houselinkRanking ? houselinkRanking : {},
      id: match.params.id
    });
    if (!!result.error) return window.toast.error("Somethings wrong, please try again " + JSON.stringify(result.error));
    this.setState({
      enableEditRanking: false,
      isUpdatingHouseLink: false,
      contractor: VarHelper.cloneDeep(current),
    });
    window.toast.info("Update HouseLink successfully");
  };

  onChangeVerify = (e, property) => {
    let { current } = this.state;
    current[property] = e.target.checked;
    this.setState({ current });
  };

  renderVerifyButtons = () => {
    const { current, isUpdatingHouseLink, enableEditRanking } = this.state;
    const verifyProps = ["isVerifiedFinances", "isVerifiedLicense", "isHouseLinkMember"];
    const verifyLabels = ["Finances", "License", "HouseLink Member"];
    const isSubmitVerify = isUpdatingHouseLink && !enableEditRanking;
    return (
      <div className="block-content">
        <h3 className="block-content__title">Need to verify</h3>
        {
          (() => {
            const { verifyDocuments } = current;
            if (!!verifyDocuments && !isEmpty(verifyDocuments)) {
              return (
                <div className="mb-16 verify-attachment">
                  <a href={VarHelper.img(verifyDocuments.file.url)} target="_blank">
                    <i className="fa fa-paperclip"> </i> Attachment:
                  </a>
                  <span> {verifyDocuments.detail} ({verifyDocuments.memberType})</span>
                </div>
              )
            }
          })()
        }
        <div className="verify-section">
          {
            verifyProps.map((item, index) => {
              return (
                <div key={`${item}${index}`} className="custom-control custom-checkbox">
                  <input id={item} name={item} type="checkbox"
                         className="custom-control-input"
                         onChange={e => this.onChangeVerify(e, item)}
                         checked={[true, 1].indexOf(current[item]) !== -1}
                  />
                  <label htmlFor={item} className="custom-control-label">
                    Verify {verifyLabels[index]}
                  </label>
                </div>
              )
            })
          }
        </div>
        <button className="btn btn-sm btn-primary" disabled={isSubmitVerify} onClick={this.updateHouseLink}>
          <i className="fa fa-dot-circle-o"> </i>  {isSubmitVerify ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    );
  };

  renderCreator = () => {
    const { current, creator } = this.state;
    if (!isEmpty(creator) && !isEmpty(current)) {
      return (
        <div className="block-content">
          <h4 className="block-content__title">Creator</h4>
          <div className="media user">
            <div className="media-left user-avatar"
                 style={{ backgroundImage: `url(${VarHelper.img(creator.avatar) || defaultImage})` }}>
            </div>
            <div className="media-body">
              <h4 className="media-heading">{creator.name}</h4>
              <p className="user__phone">
                <i className="fa fa-phone-square" aria-hidden="true"> </i> {creator.phone}
              </p>
              <p className="user__email">
                <i className="fa fa-envelope" aria-hidden="true"> </i> {creator.email}
              </p>
              <p className="user__created-date">
                <strong>Created at:</strong> {moment(current.createdAt).format('LL')}
              </p>
              <p className="user__update-date">
                <strong>Last update:</strong> {moment(current.updatedAt).format('LL')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  };

  readMoreClicked = (e) => {
    e.preventDefault();
    this.setState({ readMore: !this.state.readMore });
  };

  renderGeneral = () => {
    const { current, readMore, showBlock } = this.state;
    if (!isEmpty(current)) {
      const {
        toValue,
        contractor_type,
        contractor_company_type,
        contractor_quality_management,
        contractor_sub_type,
        project_type,
        project_sub_type,
      } = this.props.masterStore;

      const data = [
        { label: 'Revenue', value: VarHelper.textMoney(current.revenue) },
        { label: 'Total ranking', value: current.totalRanking },
        { label: 'Type', value: toValue(contractor_type, current.type) },
        { label: 'Type of company', value: toValue(contractor_company_type, current.typeOfCompany) },
        { label: 'Quality management', value: toValue(contractor_quality_management, current.qualityManagement) },
        { label: 'Unit price', value: current.unitPrice },
        { label: 'Unit revenue', value: current.unitRevenue }
      ];

      const renderDetails = (items) => {
        return items.map((item, index) => {
          return <div key={item.label + index} className="raw-group">
            <span className="key">{ item.label }</span>
            <span className="string"> </span>
            <span className="value">{ item.value }</span>
          </div>
        })
      };

      const renderList = (label, items, master, sub_master) => {
        if (!!items) {
          return <div className="list-of-items">
            <label onClick={() => this.setState({showBlock: {...showBlock, [label]: !showBlock[label]}})}>
              {v.capitalize(label)}
              {items.length ? <span className={!!showBlock[label]?'rotate-90':''}><i className="fa fa-angle-right"> </i></span> : ''}
            </label>
            <ul className={!!showBlock[label] ? 'show':'hide'}>
              {
                items.map((item, index) => {
                  if (Number(item) % 1 === 0) return <li key={item+index}>{!!master ? toValue(master, item) : item}</li>;
                  return <li key={item+index}>{!!sub_master ? toValue(sub_master, item) : item}</li>
                })
              }
            </ul>
          </div>
        }
      };

      let { description } = current;
      description = !!description ? description : '';

      return (
        <div className="block-content general">
          <h4 className="block-content__title">General</h4>
          <div className="general__content">
            <h5 className="name">{ current.name }</h5>
            <p className="description">
              { VarHelper.readMoreString(description, readMore, 200) }
              <a style={{display: description.length > 200 ? 'inline' : 'none'}}
                 onClick={e => this.readMoreClicked(e)}
                 href="#"
              >
                Show {readMore ? 'less' : 'more'}
              </a>
            </p>
            <p className="address">
              <i className="fa fa-map-marker" aria-hidden="true"> </i>
              { current.address }
            </p>
            <p><i className="fa fa-fax" aria-hidden="true"> </i> Fax: {current.fax}</p>
            <p><i className="fa fa-phone" aria-hidden="true"> </i> Phone: {current.phone}</p>
            <p><i className="fa fa-envelope" aria-hidden="true"> </i> Email: {current.email}</p>
            <p><i className="fa fa-globe" aria-hidden="true"> </i> Website: {current.website}</p>
            {renderList('typeOfContractor', current.typeOfContractor, contractor_type, contractor_sub_type)}
            {renderList('industries', current.industries, project_type, project_sub_type)}
            <h5 className="block-content__sub-title">Others</h5>
            {renderDetails(data)}
          </div>
        </div>
      )
    }
  };

  handleEnableEdit = (e) => {
    e.preventDefault();
    this.setState({ enableEdit: true });
  };

  cancelEdit = (e) => {
    e.preventDefault();
    const { contractor, current } = this.state;
    if (!isEqual(current, contractor)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) {
        return;
      }
      this.setState({
        current: VarHelper.cloneDeep(contractor),
      });
    }
    this.setState({ enableEdit: false });
  };

  onChangePhoto = (e, image) => {
    let { current } = this.state;
    const file = e.target.files[0];
    if (image === 'logo') {
      this.setState({
        logo: file,
        current: {...current, logo: URL.createObjectURL(file)}
      });
    } else if (image === 'cover') {
      this.setState({
        cover: file,
        current: {...current, wallImage: URL.createObjectURL(file)}
      })
    }
  };

  saveChangePhoto = async () => {
    const { current, logo, cover } = this.state;
    let logoURL = current.logo;
    let coverURL = current.wallImage;

    if (!!logo) {
      logoURL = await Request.upload(logo);
    }
    if (!!cover) {
      coverURL = await Request.upload(cover);
    }

    this.setState({
      logo: null,
      cover: null,
      current: {...current, logo: logoURL, wallImage: coverURL},
      contractor: {...current, logo: logoURL, wallImage: coverURL}
    });
  };

  renderImages = () => {
    const { current, enableEdit } = this.state;
    return (
      <div className="block-content logo-cover-block">
        <h3 className="block-content__title">Logo & Cover photo</h3>
        <div className="block-content__body">
          <div className="img-thumbnail logo" style={{ backgroundImage: `url(${VarHelper.img(current.logo) || defaultImage})`}}>
            <input id="c-Logo" name="c-Logo" type="file" style={{display: 'none'}} onChange={e => this.onChangePhoto(e, 'logo')} />
            <label style={{display: enableEdit ? 'inline-block' : 'none'}} title="Change logo" htmlFor="c-Logo" className="btn btn-sm btn-danger">
              <i className="fa fa-pencil" aria-hidden="true"> </i>
            </label>
          </div>
          <div className="cover" style={{ backgroundImage: `url(${VarHelper.img(current.wallImage) || IMAGE})` }}>
            <input id="c-Cover" name="c-Cover" type="file" style={{display: 'none'}} onChange={e => this.onChangePhoto(e, 'cover')} />
            <label style={{display: enableEdit ? 'inline-block' : 'none'}} title="Change cover photo" htmlFor="c-Cover" className="btn btn-sm btn-danger">
              <i className="fa fa-pencil" aria-hidden="true"> </i>
            </label>
          </div>
        </div>
      </div>
    )
  };

  renderFinances = () => {
    const { current, enableEdit } = this.state;
    // if (!current.finances) return false;

    let { finances } = current;

    if (!finances || !finances.length) {
      const dataSample = {
        "year": '',
        "revenue": '',
        "totalAsset": '',
        "totalLiabilitie": '',
        "charterCapital": '',
        "currencyUnit": ''
      };
      finances = [dataSample, dataSample, dataSample];
    }

    const renderRows = (property) => {
      const getItems = () => {
        return finances.map((item, index) => {
          if (enableEdit) {
            return <td key={'td'+index}>
              <input
                type="number"
                min={0}
                key={'fn-ip'+index}
                className="form-control"
                defaultValue={item[property]}
                onChange={(e) => {
                  finances[index][property] = e.target.value;
                  this.setState({ current: {...current, finances} })
                }}
              />
            </td>
          } else {
            return <td key={'td'+index}>{item[property]}</td>
          }
        });
      };
      return <tr><td>{v.capitalize(property)}</td>{getItems()}</tr>
    };

    return (
      <div className="block-content">
        <h3 className="block-content__title">Finances</h3>
        <div className="currency-unit">
          <label>Currency unit: </label>
          <select className="form-control"
            value={finances[0].currencyUnit}
            disabled={!enableEdit}
            onChange={(e) => {
              finances = finances.map(item => {
                item["currencyUnit"] = e.target.value; return item;
              });
              this.setState({ current: {...current, finances} })
            }}
          >
            <option value="VND">VND</option>
            <option value="USD">USD</option>
          </select>
        </div>
        <table className="table">
          <thead>
            {renderRows('year')}
          </thead>
          <tbody>
            {renderRows('revenue')}
            {renderRows('totalAsset')}
            {renderRows('totalLiabilitie')}
            {renderRows('charterCapital')}
          </tbody>
        </table>
      </div>
    )
  };

  cancelEditRanking = (e) => {
    e.preventDefault();
    const { contractor, current } = this.state;
    if (!isEqual(current.houselinkRanking, contractor.houselinkRanking)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) {
        return;
      }
      this.setState({
        current: VarHelper.cloneDeep(contractor),
      });
    }
    this.setState({ enableEditRanking: false });
  };

  renderHouseLinkRanking = () => {
    const baseData = {
      result: "29B3",
      mainCriterias: [
        {
          "title": "Financial Stability",
          "perform": "80-89%",
          "score": 5
        },
        {
          "title": "Human Resource",
          "perform": "70-79%",
          "score": 4
        },
        {
          "title": "Technical & Management ",
          "perform": "60-69%",
          "score": 5
        },
        {
          "title": "Ability Experience",
          "perform": "70-79%",
          "score": 4
        },
        {
          "title": "Health and Safety Quality",
          "perform": "70-79%",
          "score":5
        },
        {
          "title": "Reputation",
          "perform": "70-79%",
          "score": 4
        },
        {
          "title": "Culture Consideration",
          "perform": "80-89%",
          "score": 4
        }
      ]
    };

    const options = [
      { label: '90 - 100%', performValue: '90 - 100%', scoreValue: 5 },
      { label: '75 - 89%', performValue: '75 - 89%', scoreValue: 4 },
      { label: '60 - 74%', performValue: '60 - 74%', scoreValue: 3 },
      { label: '50 - 59%', performValue: '50 - 59%', scoreValue: 2 },
      { label: '< 50%', performValue: '< 50%', scoreValue: 1 },
      { label: 'Specific__', performValue: 0, scoreValue: 0 },
    ];

    const { current, enableEditRanking, isUpdatingHouseLink } = this.state;
    let { houselinkRanking } = current;

    const checkHasRanking = () => {
      if (!!houselinkRanking && houselinkRanking.hasOwnProperty('mainCriterias')) {
        return true;
      } else if (enableEditRanking) {
        houselinkRanking = baseData;
        this.setState({ current: {...current, houselinkRanking} });
        return true;
      } else {
        return false;
      }
    };

    const renderOptions = (index) => {
      const renderInput = () => {
        if (!!houselinkRanking.mainCriterias[index].specific) {
          return <div className="input-group">
              <input type="number"
                     min={0}
                     max={100}
                     defaultValue={100}
                     placeholder="Specific perform"
                     className="form-control"
                     onChange={(e) => {
                       const value = Number(e.target.value);
                       houselinkRanking.mainCriterias[index].score = VarHelper.getScoreByPerform(value);
                       houselinkRanking.mainCriterias[index].perform = value + '%';
                       const totalScore = sumBy(houselinkRanking.mainCriterias, 'score');
                       houselinkRanking.result = totalScore + VarHelper.getRanking(totalScore);
                       this.setState({ current: {...current, houselinkRanking} });
                     }}
              />
              <div className="input-group-append">
                <span className="input-group-text">%</span>
              </div>
            </div>
        }
      };
      return <div className="houselink-ranking-perform">
        <select name={'select-rank'+index} id={'select-rank'+index}
                defaultValue={houselinkRanking.mainCriterias[index].score}
                className="form-control"
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value !== 0) {
                    houselinkRanking.mainCriterias[index].score = value;
                    houselinkRanking.mainCriterias[index].perform = options.filter(item => item.scoreValue === value)[0].performValue;
                    const totalScore = sumBy(houselinkRanking.mainCriterias, 'score');
                    houselinkRanking.result = totalScore + VarHelper.getRanking(totalScore);
                    houselinkRanking.mainCriterias[index]['specific'] = false;
                    this.setState({ current: {...current, houselinkRanking} });
                  } else {
                    houselinkRanking.mainCriterias[index]['specific'] = true;
                    this.setState({ current: {...current, houselinkRanking} });
                  }
                }}>
          {
            options.map((item, index) => {
              return <option key={'select-per'+index} value={item.scoreValue}>{item.label}</option>
            })
          }
        </select>
        <div className="ranking-specific">{renderInput()}</div>
      </div>
    };

    const renderRows = () => {
      return houselinkRanking.mainCriterias.map((item, index) => {
        return <tr key={'rank-row'+index}>
          <td>{item.title}</td>
          <td>{enableEditRanking ? renderOptions(index) : item.perform}</td>
          <td>{item.score}</td>
        </tr>
      });
    };

    const renderButtons = () => {
      if (!enableEditRanking) {
        return <div className="button-group">
          <button className="btn btn-sm btn-primary"
            onClick={() => this.setState({
              enableEditRanking: !this.state.enableEditRanking
            })}><i className="fa fa-pencil" aria-hidden="true"/> Edit ranking</button>
        </div>
      } else {
        return <div className="button-group">
          <button onClick={() => this.updateHouseLink()} className="btn btn-sm btn-primary" disabled={isUpdatingHouseLink}>
            <i className="fa fa-dot-circle-o" aria-hidden="true"/> {isUpdatingHouseLink ? 'Saving...' : 'Save'}</button>
          <button className="btn btn-sm btn-danger" onClick={e => this.cancelEditRanking(e)}>
            <i className="fa fa-ban" aria-hidden="true"/> Cancel</button>
        </div>
      }
    };

    const renderContent = () => {
      if (checkHasRanking()) {
        return <table className="table table-striped">
          <thead>
          <tr>
            <th scope="col">Category</th>
            <th scope="col">Perform</th>
            <th scope="col">Score</th>
          </tr>
          </thead>
          <tbody>
          {renderRows()}
          <tr>
            <th scope="row">Total</th>
            <th scope="row"> </th>
            <th scope="row">{houselinkRanking.result}</th>
          </tr>
          </tbody>
        </table>
      } else {
        return <h5 className="text-center">No ranking</h5>
      }
    };

    return (
      <div className="block-content houselink-ranking">
        <h3 className="block-content__title">HouseLink Ranking</h3>
        {renderButtons()}
        {renderContent()}
      </div>
    )
  };

  renderUploadForm = () => {
    const { current } = this.state;
    return (
      <div className="block-content">
        <div className="block-content__title">
          <span><i className="fa fa-video-camera"> </i> Videos & Documents</span>
        </div>
        <div className="block-content__body">
          {/*videos*/}
          <label>Videos ({(current.listVideos || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control" placeholder="Video list"
                   value={!!current.listVideos ? current.listVideos.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('video')}>Edit</button>
            </div>
          </div>
          {/*documents*/}
          <label>Documents ({(current.documents || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control"
                   value={!!current.documents ? current.documents.map(item => item.url).join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('document')}>Edit</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  handleCloseModal = () => {
    this.setState({
      openVideoModal: false,
      openDocumentModal: false,
    });
  };

  handleOpenModal = (type) => {
    this.setState({
      openVideoModal: type === 'video',
      openDocumentModal: type === 'document',
    });
  };

  handleSubmitModal = async (list) => {
    const { current, openDocumentModal, openVideoModal } = this.state;

    if (openVideoModal) {
      current.listVideos = [...list];
      this.setState({ current });
    } else if (openDocumentModal) {
      current.documents = [...list];
      this.setState({ current });
    }

    this.setState({
      openDocumentModal: false,
      openVideoModal: false,
    });
  };

  renderPricing = () => {
    const { pricing } = this.state.current;

    if (!pricing || !Array.isArray(pricing)) return null;

    const getAdditionalFields = () => {
      let fieldName = [];

      pricing.forEach((item) => {
        if (!!item.fields && Array.isArray(item.fields)) {
          item.fields.forEach(itm => {
            if (!fieldName.includes(itm.label)) fieldName = [...fieldName, itm.label];
          })
        }
      });

      return fieldName;
    };

    const renderFieldContent = (items = []) => {
      return getAdditionalFields(true).map((item) => {
        let elm = <td key={'td-field-'+item}>-</td>;
        items.forEach(itm => {
          if (itm.label === item && itm.selected) {
            elm = <td className="text-success" key={'td-field-'+item}><i className="fa fa-check" aria-hidden="true"> </i></td>
          }
        });
        return elm;
      })
    };

    const renderRows = () => {
      return pricing.map((item, index) => {
        return <tr key={item.name + index}>
          <td className="first">{index + 1}</td>
          <td>{item.name}</td>
          <td>{item.price}</td>
          <td>{item.displayMode}</td>
          <td>{item.quantity}</td>
          <td>{item.currency}</td>
          {renderFieldContent(item.fields)}
        </tr>
      })
    };

    return (
      <div className="block-content">
        <h4 className="block-content__title">Pricing</h4>
        <div className="block-content__body">
          <div className="table-responsive">
            <table className="table">
              <thead>
              <tr>
                <th className="first" scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Price</th>
                <th scope="col">Mode</th>
                <th scope="col">Quantity</th>
                <th scope="col">Currency</th>
                {getAdditionalFields().map(item => <th key={'th-field-'+item}>{item}</th>)}
              </tr>
              </thead>
              <tbody>
              {renderRows()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  };

  render() {
    const { routeStore } = this.props;
    const { current, enableEdit, isSaving, openVideoModal, openDocumentModal, isLoading } = this.state;
    let content;

    if (isLoading) return (<Loading> </Loading>);

    if (enableEdit) {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Contractor detail: <strong>{current.name}</strong>
          </div>
          <div className="card-header-right">
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {this.renderEditForm()}
            </div>
            <div className="col-md-6">
              {this.renderImages()}
              {this.renderGeneral()}
              {this.renderUploadForm()}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.renderFinances()}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="button-group">
            <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={this.saveChanges}>
              <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving' : 'Save' }
            </button>
            <button className="btn btn-sm btn-danger" onClick={e => this.cancelEdit(e)}>
              <i className="fa fa-ban"> </i> Cancel
            </button>
          </div>
        </div>
      </div>
    } else {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Contractor detail: <strong>{!!current.name ? current.name : ''}</strong>
          </div>
          <div className="card-header-right">
            <div className="button-group">
              <a target="_blank" href={routeStore.web.contractorDetail(current.id, current.name)}>
                <button className="btn btn-sm btn-primary" style={{ marginRight: 10 }}>
                  <i className="fa fa-chrome"> </i> Mở bên web
                </button>
              </a>
              <button className="btn btn-sm btn-primary" onClick={e => this.handleEnableEdit(e)}>
                <i className="fa fa-pencil" aria-hidden="true"> </i> Edit
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {this.renderImages()}
              {this.renderCreator()}
              {this.renderVerifyButtons()}
              {/*documents*/}
              <div className="block-content">
                <h3 className="block-content__title">Documents ({(current.documents || []).length})</h3>
                {(current.documents || []).map((item, index) => <a target="_blank" key={'docs'+index} href={item.url}>document {index + 1}</a>)}
              </div>
            </div>
            <div className="col-md-6">
              {this.renderGeneral()}
              {/*videos*/}
              <div className="block-content">
                <h3 className="block-content__title">Videos ({(current.listVideos || []).length})</h3>
                <div className="video-block">
                  <div className="embed-container">
                    <iframe src={VarHelper.toEmbedYoutube(!!current.listVideos ? current.listVideos[0] : '') || ''} frameBorder="0" allowFullScreen> </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.renderPricing()}
              {this.renderFinances()}
              {this.renderHouseLinkRanking()}
            </div>
          </div>
        </div>
        <div className="card-footer">
          {this.renderApprove()}
          <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
            <i className="fa fa-long-arrow-left"> </i> Go back
          </button>
        </div>
      </div>
    }

    return (
      <div id="contractor-detail-page" className="animated fadeIn">
        {this.renderApprove()}
        <section>{content}</section>
        <UploadVideoModal
          open={openVideoModal}
          list={current.listVideos || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadVideoModal>
        <UploadDocumentModal
          open={openDocumentModal}
          list={current.documents || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadDocumentModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Contractors/Detail.js